import React from 'react';
import { Media } from 'reactstrap';

const Image = (props) => (
  <Media src={props.src} alt={props.alt} {...props.attrImage} />
);

export default Image;